var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-message-box" }, [
    _c("img", {
      staticClass: "boss-message-box-avatar",
      attrs: { src: require("@/assets/images/avatar-company.svg") },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "boss-layout-block" },
      [
        _c("entry-message-history-message-detail", {
          attrs: {
            date: _vm.date,
            "is-read": _vm.isRead,
            subject: _vm.subject,
            body: _vm.body,
            "is-remind-mail": _vm.isRemindMail,
          },
        }),
        _vm._v(" "),
        _vm.interviewAdjustment
          ? _c("entry-message-history-interview-adjustment", {
              attrs: {
                "candidate-dates": _vm.interviewAdjustment.candidateDates,
                place: _vm.interviewAdjustment.place,
                "google-map-place": _vm.interviewAdjustment.googleMapPlace,
                duration: _vm.interviewAdjustment.duration,
                "content-names": _vm.interviewAdjustment.contentNames,
                remarks: _vm.interviewAdjustment.remarks,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.files.length
          ? [
              _c(
                "div",
                {
                  staticClass: "pega-file-download-content",
                  attrs: { "data-test": "file-content" },
                },
                [_vm._v("\n        添付ファイル\n      ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.files, function (file, i) {
                return _c(
                  "div",
                  { key: i, staticClass: "position-relative pega-break" },
                  [
                    _c("span", { attrs: { "data-test": "file-label-" + i } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("formatFile")(file)) +
                          "\n        "
                      ),
                    ]),
                  ]
                )
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }